<template>
  <div class="project_main" v-if="project.projectId">
    <div class="header_margin">
        <!-- <div class="pull-right" v-if="isMigrated">
            <h3><span class="label label-default" style="color: #FFFFFF">Migrated</span></h3>
        </div> -->
        <span v-if="project.projectId">
            <router-link :to="{ path: '/Project/' + project.projectId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
        </span>
        <span v-if="project.inactive" class="project_label" style="color: red;"><b>INACTIVE</b></span>
        <span class="project_label">Project Name:</span>
        <span class="project_value">{{ project.name }}</span>
        <span>
            <span class="project_label">DB Number:</span>
            <span class="project_value">{{ project.dbNumber }}</span>
        </span>
        <span v-if="project.expeditedReview" class="project_label" style="color: red;"><b>EO 14156</b></span>
    </div>
    <div class="header_margin">
        <span>
            <span class="project_label">Project Type:</span>
            <span class="project_value">{{ project.projectTypeDescription }}</span>
        </span>
    </div>
    <div class="header_margin">
        <span>
            <span class="project_label">Lead Agency:</span>
            <span class="project_value">{{ leadAgencyDescription }}</span>
        </span>
        <span>
            <span class="project_label">Agency Number:</span>
            <span class="project_value">{{ project.agencyNumber }}</span>
        </span>
    </div>
    <div class="header_margin">
        <span>
            <span class="project_label">Client:</span>
            <span class="project_value">{{ clientDescription }}</span>
        </span>
    </div>
    <div class="header_margin">
        <span>
            <span class="project_label">Field Org:</span>
            <span class="project_value">{{ fieldOrgDescription }}</span>
        </span>
        <span>
            <span class="project_label">Field Org Number:</span>
            <span class="project_value">{{ project.fieldOrgNumber }}</span>
        </span>
        <div v-if="isShpo" style="display: inline-block; margin: 10px 10px 0px 20px;" >
            <button class="btn btn-primary" style="margin: 0;" v-on:click="$refs['commentModal'].open()">
                SHPO Comments <span class="badge">{{commentList.length}}</span>
            </button>
        </div>
        <div v-if="isShpo" style="display: inline-block; margin: 10px 10px 0px 20px;" >
            <button class="btn btn-primary" style="margin: 0;" v-on:click="$refs['randcModal'].open()">
                RandC Data
            </button>
        </div>
    </div>
    <modal ref="commentModal">
        <div slot="header" class="row">
            <h3 class="pull-left align-bottom">SHPO Comments</h3>
            <button class="btn pull-right" v-on:click="$refs['commentModal'].close()">X</button>
        </div>
        <div slot="body">
            <div>
                <v-client-table :data="commentList" :columns="commentGridSpec.columns" :options="commentGridSpec.options">
                    <template slot="delete" slot-scope="props">
                        <div style="text-align: center">
                            <a  class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteComment(props.row)"></a>
                        </div>
                    </template>
                </v-client-table>
            </div>
            <div class="form-group">
                <div>
                    <textarea class="form-control" rows="4" v-model="commentDto.comment" />
                </div>
            </div>
        </div>
        <div slot="footer" class="">
            <div class="">
                <button class="btn btn-primary col-md-3" type="button" name="save" v-on:click="saveShpoComment()">Add Comment</button>
                <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['commentModal'].close()">Close</button>
            </div>
        </div>
    </modal>
    <modal ref="randcModal">
        <div slot="header" class="row">
            <h3 class="pull-left align-bottom">RandC Data</h3>
            <button class="btn pull-right" v-on:click="$refs['randcModal'].close()">X</button>
        </div>
        <div slot="body">
            <div>
                <v-client-table :data="projectRandCList" :columns="randcGridSpec.columns" :options="randcGridSpec.options">
                </v-client-table>
            </div>
        </div>
        <div slot="footer" class="">
            <div class="">
                <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['randcModal'].close()">Close</button>
            </div>
        </div>
    </modal>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import { mapState } from 'vuex'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import projectShpoCommentService from '@/services/projectShpoCommentService.js'
import organizationService from '../services/organizationService'
import modal from '@/components/Modal.vue'
import projectService from '../services/projectService'

export default {
    name: 'projectHeader',
    components: {
        modal
    },
    props: ['project'],
    data: function () {
        return {
            isDebug: false,
            commentList: [],
            commentDto: {
                comment: ''
            },
            organizationList: [],
            commentGridSpec: {
                columns: ['comment', 'createdDate', 'createdBy', 'delete'],
                options: {
                    dateFormat: 'YYYY-MM-DD HH:mm:ss',
                    dateColumns: ['createdDate'],
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        comment: 'Comment',
                        createdDate: 'Created Date',
                        createdBy: 'Created By',
                        delete: 'Delete'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'createdDate'
                    }
                }
            },
            projectRandCList: [],
            randcGridSpec: {
                columns: ['revno', 'randCname', 'randCsRevPerson', 'randCreviewer', 'randCrevDt', 'randCrespons'],
                options: {
                    dateFormat: 'YYYY-MM-DD HH:mm:ss',
                    dateColumns: ['randCrevDt'],
                    perPage: 5,
                    perPageValues: [5, 10, 25],
                    headings: {
                        revno: 'REVNO',
                        randCname: 'Name',
                        randCsRevPerson: 'S Review Person',
                        randCreviewer: 'Reviewer',
                        randCrevDt: 'Review Date',
                        randCrespons: 'Response Type'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'revno'
                    }
                }
            }
        }
    },
    computed: {
        isMigrated: function () {
            return (this.project.projectId > 0 && this.project.projectId < 200000)
        },
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isShpo: function () {
            var shpoRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        leadAgencyDescription: function () {
            if (this.project) {
                return this.project.agencyDescription ||
                (this.organizationList.find(x => { return x.organizationId === this.project.agencyId }) || {description: ''}).description
            } else {
                return ''
            }
        },
        clientDescription: function () {
            if (this.project) {
                return this.project.clientDescription ||
                (this.organizationList.find(x => { return x.organizationId === this.project.clientId }) || {description: ''}).description
            } else {
                return ''
            }
        },
        fieldOrgDescription: function () {
            if (this.project) {
                return this.project.fieldOrgDescription ||
                (this.organizationList.find(x => { return x.organizationId === this.project.fieldOrganizationId }) || {description: ''}).description
            } else {
                return ''
            }
        }
    },
    watch: {
        project: function (val) {
            if (this.project.projectId && this.isShpo) {
                this.loadProjectShpoComment()
                this.loadProjectRandC()
            }
        }
    },
    created () {
        loggingService.log(this.isDebug, 'projectHeader', 'created, project: ' + this.project)
    },
    mounted () {
        loggingService.log(this.isDebug, 'projectHeader', 'mounted, project: ' + this.project)
        this.loadOrganizations()
        if (this.project && this.project.projectId && this.isShpo) {
            this.loadProjectShpoComment()
            this.loadProjectRandC()
        }
    },
    methods: {
        loadProjectShpoComment () {
            this.commentDto.projectId = this.project.projectId
            return projectShpoCommentService.listByProjectId(this.$http, this.project.projectId).then(response => {
                if (response.data) {
                    this.commentList = response.data
                    return response.data
                }
            })
        },
        loadProjectRandC () {
            return projectService.listProjectRandC(this.$http, this.project.projectId).then(response => {
                if (response.data) {
                    this.projectRandCList = response.data
                    return response.data
                }
            })
        },
        saveShpoComment () {
            this.commentDto.projectId = this.project.projectId
            if (!this.commentDto.comment) this.commentDto.comment = ''
            projectShpoCommentService.put(this.$http, this.commentDto).then(response => {
                this.loadProjectShpoComment()
                this.commentDto.comment = ''
            })
        },
        loadOrganizations () {
            loggingService.log(this.isDebug, 'projectHeader', 'loadOrganizations')
            return organizationService.listLookup(this.$http).then(response => {
                this.organizationList = response.data
            })
        },
        deleteComment (commentDto) {
            var comment = commentDto.comment
                ? (commentDto.comment.length > 30 ? commentDto.comment.substr(0, 30) + '...' : commentDto.comment) : ''
            if (confirm(`Are you sure you wish to delete this comment: "${comment}"?`)) {
                projectShpoCommentService.remove(this.$http, commentDto.projectShpoCommentId).then(response => {
                    this.loadProjectShpoComment()
                })
            }
        }
    }
}
</script>

<style>
    .project_main {
        padding: 10px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f5f5f5;
    }
    .project_label {
        margin-right: 20px;
        color: #555555;
        font-weight: normal;
        font-size: 1.2em;
    }
    .project_value {
        margin-right: 20px;
        font-weight: bold;
        font-size: 1.2em;
    }
    .header_margin {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// ProjectHeader.vue?e70c0c5c